import ubaRequest from './ubaRequest';
import errorSvc from './errorService';

const ENDPOINT ='eventgroup';
export async function createEventGroup (param) {
  try {
    const url = `${ENDPOINT}/`;
    return await ubaRequest.post(url, param);
  } catch (error) {
    errorSvc.onError(error);
    return false;
  }
}

export async function deleteEventGroup (param) {
  try {
    const url = `${ENDPOINT}/${param.id}`;
    return await ubaRequest.del(url, param);
  } catch (error) {
    errorSvc.onError(error);
    return false;
  }
}

export async function getEventGroups (param) {
  try {
    const url = `${ENDPOINT}/`;
    return await ubaRequest.get(url, param);
  } catch (error) {
    errorSvc.onError(error);
    return false;
  }
}

export async function getEventGroupByName (param) {
  try {
    const url = `${ENDPOINT}/name/${param.name}`;
    return await ubaRequest.get(url);
  } catch (error) {
    errorSvc.onError(error);
    return false;
  }
}

export async function updateEventGroup (param) {
  try {
    const url = `${ENDPOINT}/${param.id}`;
    return await ubaRequest.put(url, param);
  } catch (error) {
    errorSvc.onError(error);
    return false;
  }
}

export async function getStats (param) {
  let key = `${param.eventContent}_${param.content}_${param.currentContextPath}` +
  `_${param.scope}_${param.definitionType}_${param.beginTime}_${param.pathCondition}`;
  if (allStats[key]) {
    return allStats[key];
  }

  let stats = null;
  try {
    const url = `${ENDPOINT}/metric`;
    let response = await ubaRequest.post(url, param);
    if (response.json && response.json.data) {
      stats = response.json.data;
    }
    allStats[key] = stats;
    return stats;
  } catch (error) {
    errorSvc.onError(error);
    return stats;
  }
}

export default {
  createEventGroup,
  deleteEventGroup,
  getEventGroups,
  getEventGroupByName,
  updateEventGroup,
  getStats
};

let allStats = {};



/** WEBPACK FOOTER **
 ** ./src/services/eventGroupService.js
 **/